import { isWebviewContext } from './utils/webview';

export default {
    actionLogging: {
        logToConsole: import.meta.env.VITE_ACTION_LOGGING_LOG_TO_CONSOLE === 'true',
    },
    api: {
        action: {
            url: import.meta.env.VITE_API_URL_ACTION,
        },
        backend: {
            url: import.meta.env.VITE_API_URL_BACKEND,
        },
    },
    auth: {
        inlineClientId: import.meta.env.VITE_API_IDENTITY_PROVIDER_CLIENT_ID_INLINE,
    },
    sentry: {
        active: (import.meta.env.VITE_SENTRY === 'true'),
        dsn: import.meta.env.VITE_SENTRY_DSN ?? '',
        tracesSampleRate: 0.001,
    },
    googleRecaptcha: {
        active: (import.meta.env.VITE_GOOGLE_RECAPTCHA === 'true') && !isWebviewContext(),
        siteKey: import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY ?? '',
    },
    gtm: {
        active: (import.meta.env.VITE_GTM === 'true') && !isWebviewContext(),
        id: import.meta.env.VITE_GTM_ID ?? '',
        logToConsole: import.meta.env.VITE_LOG_TRACKING_TO_CONSOLE === 'true',
    },
    xOriginHeader: import.meta.env.VITE_X_ORIGIN,
    leavingAlert: {
        active: (import.meta.env.VITE_LEAVING_ALERT === 'true'),
    },
    release: import.meta.env.VITE_RELEASE,
    version: import.meta.env.VITE_VERSION,
    environment: import.meta.env.VITE_APP_ENV,
    extractCvEnabled: (import.meta.env.VITE_EXTRACT_CV_ENABLED === 'true'),
};
